import { STATE_KEY } from './drive.const';

const mainSelector = (state: any) => state[STATE_KEY];

export const selectFolderList = (state: any) => mainSelector(state).folders;
export const selectCurrentFolder = (state: any) =>
  mainSelector(state).currentFolder;
export const selectGlobalFilters = (state: any) =>
  mainSelector(state).globalFilters;
